
  import { defineComponent } from 'vue';
  import { TabList } from '@headlessui/vue';

  import type { Component, PropType } from 'vue';
  import type { DomClassesProp } from '@/typings/class-style-binding';

  export default defineComponent({
    name: 'AppTabList',

    components: {
      TabList,
    },

    props: {
      ...TabList.props,

      extendedTabListDomClasses: {
        type: [String, Array, Object] as PropType<DomClassesProp>,
        default: null,
      },
    },

    computed: {
      isCustom(): boolean {
        return this.$attrs.custom !== undefined;
      },

      tabListComponent(): Component | string {
        return this.isCustom ? 'div' : TabList;
      },
    },
  });
